module.exports = "<div class=\"ql-container ql-snow editor-view\" style=\"border-width: 0; word-break: break-word\">\n  <div class=\"ql-editor editor-view\" [innerHTML]=\"content | safeHtml\" (click)=\"openUrlInNewTab($event)\">\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./shared/components/common/sn-quill-view/sn-quill-view.html
// module id = ./shared/components/common/sn-quill-view/sn-quill-view.html
// module chunks = 0